// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"d773ed02","936":"1d92373d"}[chunkId] + ".chunk.css";
};